<div>
  @if (state === 'error') {
    <mwe-inline-notification [messageKey]="alertMessageKey" [titleKey]="alertTitleKey" type="danger" />
  }
  @for (group of addressGroups; track $index) {
    <mwe-products-group
      [address]="group.address"
      [productsInput]="group.products"
      [showCompanyCorrelation]="true"
      state="list"
      [isClickableCard]="false"
    />
  }
</div>
